<template>
  <div class="animated fadeIn">
    <b-form
      @submit.prevent="onHandleStoreTicket"
      name="ticketForm"
      data-vv-scope="form-ticket"
    >

      <div>
        <b-tabs content-class="mt-3" fill>
          <b-tab title="Datos generales" active>

            <b-row>
              <b-col sm="12" align-v="center">

                <b-row>
                  <b-col sm="12">
                    <b-row>
                      <b-col sm="12">
                        <b-form-group>
                          <label for="type_matter" class="w-100">
                            Asunto <span class="text-danger">(*)</span>
                          </label>
                          <treeselect
                            id="type_matter"
                            name="type_matter"
                            placeholder="Asuntos"
                            :options="typesOfMatters"
                            :searchable="true"
                            :multiple="false"
                            data-vv-as=" "
                            v-model="selectedTicket.type_matter"
                            v-validate="'required'"
                            @input="validateTypeMatterField"
                            @change="() => typeMatterHasOtherOption()"
                          >
                          </treeselect>
                          <span class="text-danger span-error small">{{
                              errors.first("form-ticket.type_matter")
                          }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="(selectedTicket.type_matter && typeof selectedTicket.type_matter === 'object') ? (selectedTicket.type_matter.find(type => +type === 4) ? true : false) : false">
                      <b-col sm="12">
                        <b-form-group>
                          <label for="name_product">Nombre del producto <span class="text-danger">(*)</span></label>
                          <b-form-input
                            type="text"
                            id="name_product"
                            name="name_product"
                            data-vv-as=" "
                            v-model="selectedTicket.name_product"
                            placeholder="Nombre del Producto"
                            v-validate="'required|min:3|max:255'"
                          ></b-form-input>
                          <span class="text-danger span-error small">{{
                              errors.first("form-ticket.name_product")
                          }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="12">
                        <b-form-group>
                          <label for="asunto">Nombre del producto / # Solicitud <span class="text-danger">(*)</span></label>
                          <b-form-input
                            type="text"
                            id="asunto"
                            name="asunto"
                            data-vv-as=" "
                            v-model="selectedTicket.asunto"
                            placeholder="Descripción/Nombre del producto"
                            v-validate="'required|min:3|max:255'"
                          ></b-form-input>
                          <span class="text-danger span-error small">{{
                            errors.first("form-ticket.asunto")
                          }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12">
                        <b-form-group>
                            <label for="form_manufacturer_id" class="w-100">
                            Fabricante
                            </label>
                            <el-select
                            id="form_manufacturer_id"
                            name="form_manufacturer_id"
                            filterable
                            placeholder="Buscar fabricante"
                            v-model="selectedTicket.form_manufacturer_id"
                            no-data-text="No hay datos que coincidan"
                            no-match-text="No hay datos que coincidan"
                            :remote-method="getProducerByName"
                            remote
                            clearable
                            >
                            <el-option
                                v-for="item in producers"
                                :key="item.id"
                                :label="item.nombre"
                                :value="item.id"
                            />
                            </el-select>
                        </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="customFields && customFields.length">
                      <b-col sm="12">
                        <b-form-group>
                          <label for="custom_field_id" class="w-100">
                            Campo personalizado
                          </label>
                          <el-select
                            id="custom_field_id"
                            name="custom_field_id"
                            placeholder="Seleccionar campo personalizado"
                            v-model="selectedTicket.custom_field_id"
                            no-data-text="No hay datos que coincidan"
                            no-match-text="No hay datos que coincidan"
                            clearable
                          >
                            <el-option
                              v-for="item in customFields"
                              :key="item.id"
                              :label="item.nombre"
                              :value="item.id"
                            />
                          </el-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="customFields && customFields.length">
                      <b-col sm="12">
                        <b-form-group>
                          <label for="custom_field_value">
                            Valor del campo personalizado
                            <span v-if="selectedTicket.custom_field_id" class="text-danger">(*)</span>
                          </label>
                          <b-form-input
                            type="text"
                            id="custom_field_value"
                            name="custom_field_value"
                            v-model="selectedTicket.custom_field_value"
                            placeholder="Ingrese el valor"
                            maxlength="255"
                            :disabled="!selectedTicket.custom_field_id"
                            v-validate="getValidationForCustomFieldValue()"
                          ></b-form-input>
                          <span class="text-danger span-error small">{{
                            errors.first("form-ticket.custom_field_value")
                          }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="basicInfoUser && basicInfoUser.tipo_multiusuario">
                      <b-col sm="12">
                        <b-form-group>
                          <label for="user_name">Nombre Usuario <span class="text-danger">(*)</span></label>
                          <b-form-input
                            type="text"
                            id="user_name"
                            name="user_name"
                            data-vv-as=" "
                            v-model="selectedTicket.user_name"
                            placeholder="Nombre Usuario"
                            v-validate="getValidation('min:3|max:255')"
                          ></b-form-input>
                          <span class="text-danger span-error small">{{
                            errors.first("form-ticket.user_name")
                          }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="basicInfoUser && basicInfoUser.tipo_multiusuario">
                      <b-col sm="12">
                        <b-form-group>
                          <label for="user_email">Correo electrónico Usuario <span class="text-danger">(*)</span></label>
                          <b-form-input
                            type="text"
                            id="user_email"
                            name="user_email"
                            data-vv-as=" "
                            v-model="selectedTicket.user_email"
                            placeholder="Correo electrónico Usuario"
                            v-validate="getValidation('email')"
                          ></b-form-input>
                          <span class="text-danger span-error small">{{
                            errors.first("form-ticket.user_email")
                          }}</span>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row v-if="!admin">
                      <b-col sm="12">
                        <b-form-group>
                          <label for="empresa">Empresa</label>
                          <b-form-input
                            type="text"
                            id="empresa"
                            v-model="selectedTicket.empresa"
                            placeholder="Ingrese la empresa"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="12">
                        <b-form-group>

                          <div v-if="selectedTicket.digit_location" class="mb-2">
                            <small class="text-info">
                              <i class="fa fa-info-circle"></i>
                              Para registrar una ubicación temporal, seleccione la ubicación padre y escriba el nombre de la ubicación temporal.
                            </small>
                          </div>

                          <label for="ubicacion" class="w-100">
                            <span v-if="selectedTicket.digit_location">Ubicación padre </span>
                            <span v-else>Ubicación</span>
                            <span v-if="selectedTicket.digit_location" class="text-danger">(*)</span>
                            <b-form-checkbox
                              v-model="selectedTicket.digit_location"
                              class="float-right"
                              @change="resetSelectedLocation"
                              v-b-tooltip.top.hover="'Asignar ubicación temporal'"
                              :value="true"
                              :unchecked-value="false"
                            />
                          </label>

                          <b-row class="m-0">
                            <b-col :cols="selectedTicket.digit_location ? 8 : 12" class="pl-0 pr-0">
                              <Treeselect
                                ref="treeselect"
                                :value="value"
                                name="slq_locations_id"
                                id="slq_locations_id"
                                clearable
                                :options="treeWithChildrens"
                                :normalizer="normalizer"
                                :placeholder="selectedTicket.digit_location ? 'Seleccionar ubicación padre' : 'Seleccionar ubicación'"
                                :flatten-search-results="false"
                                :disable-fuzzy-matching="true"
                                :multiple="true"
                                data-vv-as="ubicación"
                                :disable-branch-nodes="!selectedTicket.digit_location"
                                v-model="selectedTicket.slq_locations_id"
                                :defaultExpandLevel="Infinity"
                                no-results-text="No se encontraron resultados."
                                :max-height="300"
                                class="custom-treeselect w-100"
                                value-consists-of="ALL"
                                noOptionsText="No hay resultados para mostrar"
                                v-validate="getValidationForLocation()"
                                @select="handleLocationSelect"
                                @input="validateLocationField"
                                @search-change="onSearchChange"
                              >
                                <label slot="option-label" slot-scope="{ node, labelClassName }" :class="[labelClassName, getNodeClass(node)]">
                                  <span v-html="getLocationDisplayName(node)"></span>
                                </label>
                              </Treeselect>
                              <span class="text-danger span-error small">{{
                                errors.first("form-ticket.slq_locations_id")
                              }}</span>
                            </b-col>
                            <b-col v-if="selectedTicket.digit_location" cols="4" class="pr-0">
                              <b-form-input
                                id="ubicacion_diligenciada"
                                name="ubicacion_diligenciada"
                                v-model="selectedTicket.ubicacion_diligenciada"
                                placeholder="Ubicación temporal"
                                class="w-100"
                                v-validate="'required'"
                                data-vv-as=" "
                              ></b-form-input>
                              <span class="text-danger span-error small">{{
                                errors.first("form-ticket.ubicacion_diligenciada")
                              }}</span>
                            </b-col>
                          </b-row>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col sm="12">
                        <label>Mensaje</label>
                        <b-form-textarea
                          id="mensaje"
                          name="mensaje"
                          v-model="selectedTicket.mensaje"
                          size="lg"
                          placeholder="Mensaje"
                          v-validate="'max:500|min:3'"
                          rows="4"
                          maxlength="501"
                        ></b-form-textarea>
                        <div class="d-flex justify-content-end">
                          <small class="text-muted" v-show="selectedTicket.mensaje && typeof selectedTicket.mensaje === 'string'">
                            Caracteres {{ selectedTicket.mensaje.length }}
                          </small>
                        </div>
                        <span class="text-danger span-error small">{{
                          errors.first("form-ticket.mensaje")
                        }}</span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row sm="12" class="mt-2">
                  <b-col>
                    <label>
                      Seleccionar archivo
                      <span v-if="isAttachmentRequired" class="text-danger">(*)</span>
                    </label>
                    <b-form-file
                      id="adjunto"
                      placeholder="Selecciona un archivo"
                      type="file"
                      name="adjunto"
                      browse-text="Buscar"
                      @change="changeFile()"
                      :class="{ 'is-invalid': hasAttachmentError }"
                    >
                    </b-form-file>
                    <div v-if="hasAttachmentError" class="mt-1">
                      <small class="text-danger">
                        <i class="fa fa-exclamation-circle"></i>
                        Se requiere adjuntar un archivo
                      </small>
                    </div>
                  </b-col>
                </b-row>

              </b-col>
            </b-row>

          </b-tab>
        </b-tabs>
      </div>

      <b-row class="mt-4">
        <b-col md="6" class="text-left">
          <b-button variant="light" type="bottom" @click="() => hideModal()">
            Cancelar
          </b-button>
        </b-col>
        <b-col md="6" class="text-right">
          <b-button variant="primary" type="submit" :disabled="errors.any('form-ticket')">
            <i class="fa fa-save mr-1"></i>
            Crear ticket
          </b-button>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>



<script>
import Vue from "vue";
import { mapState, mapActions, mapMutations } from "vuex";
import VeeValidate, { Validator } from "vee-validate";
import { getAcls } from '../../plugins/acl';
import es from "vee-validate/dist/locale/es";
import Treeselect from "@riophae/vue-treeselect";

Vue.use(VeeValidate, {
  fieldsBagName: "vvFields",
  events: "change",
});
Validator.localize("es", es);
Validator.localize("es", {
  custom: {
    custom_field_value: {
      required: "Valor del campo personalizado es obligatorio",
    },
  },
});


export default {
  name: "tickets",
  // companyId: empresa de la cual se cargan los campos personalizados. El módulo
  // de tickets no la envía, por lo que se usan los de la empresa del usuario.
  props: ["admin",'hideModal','companyId'],
  components: {
    Treeselect
  },
  async mounted() {
    const acls = getAcls();
    // Se cargan de forma independiente para que un fallo en la información
    // básica del usuario no impida cargar los campos personalizados.
    await Promise.all([
      this.getBasicInfo(acls.usuario_id).catch(() => {}),
      this.getTicketCustomFields(this.companyId || null)
    ]);
  },
  data() {
    return {
      value: null,
      searchQuery: '',
      previousLocationId: null
    };
  },
  watch: {
    'selectedTicket.slq_locations_id': {
      handler: function(newVal, oldVal) {
        if (this.selectedTicket.digit_location && Array.isArray(newVal) && newVal.length > 1) {
          const oldArray = Array.isArray(oldVal) ? oldVal : [];
          const newElement = newVal.find(item => !oldArray.includes(item));

          this.assignDataSelectedTicket({
            slq_locations_id: newElement ? [newElement] : [newVal[0]]
          });
        }
      },
      deep: true
    },
    'selectedTicket.custom_field_id': function (newVal) {
      if (!newVal) {
        this.assignDataSelectedTicket({ custom_field_value: '' });
      }
    }
  },
  computed: {
    ...mapState("location", ["treeWithChildrens"]),
    ...mapState("tickets", [
      "defaultTicket",
      "selectedTicket",
      "status",
      "action",
      "pantalla",
      "loading",
      'manufacturers',
      'typesOfMatters',
      'customFields',
      'error'
    ]),
    ...mapState("productos_et", [
      "products",
      "filtroEt",
      "empresas",
      "selectedProduct",
      "id_empresa",
    ]),
    ...mapState("accidents_high", [
      "producers",
    ]),
    ...mapState("autenticacion", ["basicInfoUser"]),

    // Computed property para verificar si el adjunto es requerido
    isAttachmentRequired() {
      return this.isTestInside();
    },

    // Computed property para verificar si hay error de validación del adjunto
    hasAttachmentError() {
      return this.isAttachmentRequired && !this.hasAttachedFile();
    }
  },
  methods: {
    ...mapActions("tickets", {
      storeTicket: 'guardaTicket'
    }),
    ...mapActions("tickets", ["getTicketCustomFields"]),
    ...mapActions("autenticacion", ["getBasicInfo"]),
    ...mapActions("productos_et", [
      "getEmpresaFiltro"
    ]),
    ...mapActions("accidents_high", [
      "getProducerByName",
    ]),
    ...mapMutations("tickets", ["limpiarTicket", "setLoading", "assignDataSelectedTicket"]),
    ...mapMutations("dashboard", ["load"]),
    resetSelectedLocation() {
      this.assignDataSelectedTicket({
        ubicacion_diligenciada: '',
        slq_locations_id: null
      });
    },
    getValidation(rules = ''){
        if(this.basicInfoUser && this.basicInfoUser.tipo_multiusuario)rules = `required|${rules}`;
        return rules;
    },
    getValidationForCustomFieldValue() {
      return this.selectedTicket.custom_field_id ? 'required' : '';
    },
    getValidationForLocation() {
      let rules = this.getValidation();

      if (this.selectedTicket.digit_location) {
        rules = 'required';
      }

      return rules;
    },
    validateTemporaryLocation() {
      if (this.selectedTicket.digit_location) {
        if (!this.selectedTicket.slq_locations_id || this.selectedTicket.slq_locations_id.length === 0) {
          this.$alertError("Debe seleccionar la ubicación padre cuando se usa ubicación temporal.", 5000);
          return false;
        }
        if (!this.selectedTicket.ubicacion_diligenciada || this.selectedTicket.ubicacion_diligenciada.trim() === '') {
          this.$alertError("Debe ingresar el nombre de la ubicación temporal.", 5000);
          return false;
        }
      }
      return true;
    },
    validateUserEmail() {
      if (this.basicInfoUser && this.basicInfoUser.tipo_multiusuario) {
        if (!this.selectedTicket.user_email || this.selectedTicket.user_email.trim() === '') {
          this.$alertError("El correo electrónico del usuario es requerido.", 5000);
          return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.selectedTicket.user_email)) {
          this.$alertError("El correo electrónico debe tener un formato válido.", 5000);
          return false;
        }
      }
      return true;
    },
    /**
     * Verifica si entre los tipos seleccionados esta la opción Otro.
     *
     * @returns bool
     */
     typeMatterHasOtherOption() {
      this.assignDataSelectedTicket({ ...this.selectedTicket, name_product: "" });
    },
    normalizer(node) {
      return {
        ...node,
        disabled: !this.selectedTicket.digit_location,
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    /**
     * Capturar el texto de búsqueda del Treeselect
     *
     */
    onSearchChange(query) {
      this.searchQuery = query || '';
    },
    getLocationDisplayName(node) {
      return node.label;
    },
    getNodeClass() {
      return '';
    },

    changeFile(){
        const inputFile = document.getElementById("adjunto");
        const maxSizeMB = 10;
        const maxSizeByte = maxSizeMB * 1024 * 1024;
        const file = inputFile.files[0];
        if(file && file.size > maxSizeByte){
            inputFile.value = '';
            this.$alertError(`El archivo seleccionado supera el limite de ${maxSizeMB}MB permitido.`,5000);
        }

        // Forzar actualización de la computed property para limpiar errores
        this.$forceUpdate();
    },
    /**
     * Verifica si el asunto seleccionado es "Evaluación de ingreso"
     * @returns {boolean}
     */
    isTestInside() {
      return this.selectedTicket.type_matter === 5 ? true : false;
    },

    /**
     * Verifica si se ha adjuntado un archivo
     * @returns {boolean}
     */
    hasAttachedFile() {
      const inputFile = document.getElementById("adjunto");
      return inputFile && inputFile.files && inputFile.files.length > 0;
    },

    /**
     * Valida si el adjunto es obligatorio para "Evaluación de ingreso"
     * @returns {boolean}
     */
    validateAttachmentRequired() {
      if (this.isTestInside() && !this.hasAttachedFile()) {
        this.$alertError("Se requiere adjuntar un archivo para continuar cuando el Asunto es 'Evaluación de ingreso'.", 5000, true, 'Tickets', 'info');
        return false;
      }
      return true;
    },

    validateLocationField() {
      this.$nextTick(() => {
        this.$validator.validate('form-ticket.slq_locations_id');
      });
    },

    validateTypeMatterField() {
      this.$nextTick(() => {
        this.$validator.validate('form-ticket.type_matter');
      });
    },

    handleLocationSelect(node) {
      if (this.selectedTicket.digit_location) {
        this.$nextTick(() => {
          this.assignDataSelectedTicket({
            slq_locations_id: [node.id]
          });
        });
      }
    },

    async onHandleStoreTicket() {
      const acls = getAcls();

      this.$validator.validateAll("form-ticket").then(async (result) => {
        if (result) {
          // Validar adjunto obligatorio para "Evaluación de ingreso"
          if (!this.validateAttachmentRequired()) {
            return;
          }

          if (!this.validateTemporaryLocation()) {
            return;
          }

          if (!this.validateUserEmail()) {
            return;
          }

          const formData = new FormData();

          const file = document.getElementById("adjunto").files[0];
          if (file) formData.append("file", file);

          formData.append("temporary_company_id", acls.empresa);
          formData.append("type_matter", JSON.stringify(this.selectedTicket.type_matter));
          formData.append("asunto", this.selectedTicket.asunto);
          formData.append("name_product", this.selectedTicket.name_product || '');
          if (this.selectedTicket.form_manufacturer_id) formData.append("manufacturer_id", this.selectedTicket.form_manufacturer_id);
          if (this.selectedTicket.slq_locations_id) formData.append("locations", JSON.stringify(this.selectedTicket.slq_locations_id));
          formData.append("nombre", this.selectedTicket.nombre);
          formData.append("mensaje", this.selectedTicket.mensaje);
          formData.append("email", this.selectedTicket.email);
          formData.append("user_name", this.selectedTicket.user_name || '');
          formData.append("user_email", this.selectedTicket.user_email || '');
          if (this.selectedTicket.slq_locations_id) formData.append("slq_locations_id", this.selectedTicket.slq_locations_id);
          formData.append("ubicacion_diligenciada", this.selectedTicket.ubicacion_diligenciada || '');
          if (this.selectedTicket.custom_field_id) {
            formData.append("custom_field_id", this.selectedTicket.custom_field_id);
            formData.append("custom_field_value", this.selectedTicket.custom_field_value || '');
          }

          const payload = {
            data: formData,
            callback: this.callbackStoreTicket
          }
          await this.storeTicket(payload);

        }
      });
    },

    callbackStoreTicket(status, response) {
      if (!status) return;

      this.$validator.reset();

      // Si el usuario selecciona "Evaluación de ingreso" como asunto, al momento de guardar el ticket
      if (response && typeof response === 'object' && response.ticket_id && response.type_subject == 5) {

        if (this.hideModal) {
          this.hideModal();
        }

        // Redirigir automáticamente a la vista detallada del ticket.
        this.$router.push({
          name: 'tickets-detalle',
          params: {
            id: response.ticket_id,
            company_id : response.company_id,
            is_new: true,
            subject: response.type_subject
          }
        })

        // Mostrar el siguiente mensaje de advertencia/información
        this.$alertError("Se requiere adjuntar la FDS para continuar con el proceso", 10000, true, 'Tickets', 'info');
      } else {
        if (this.hideModal) {
          this.hideModal();
        }
      }
    },

    async buscarEmpresa(query) {
      if (query.length >= 3) {
        await this.getEmpresaFiltro(query);
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.input:hover {
  cursor: pointer !important;
}

.is-invalid {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.text-info {
  color: #17a2b8 !important;
}
</style>
